import logo from "../resources/logo.png";
import React from "react";
import "./Header.css"
import {Link} from "react-router-dom";

export const Header = () => {
  return <div className="header">
    <div className="content">
      <div className="links-container">
        <div className="links">
          <a rel="noopener noreferrer" target="blank" href="https://hexagon.com">
            Hexagon
          </a>
          <a rel="noopener noreferrer" target="blank"
             href="https://hexagon.com/company/careers/job-listings#jl_country=Belgium&nearme=1&jl_e=0">Other
            careers</a>
          <a href="mailto:jobs.luciad.gsp@hexagon.com">
            Contact us
          </a>
        </div>
      </div>
      <Link to="/">
        <div className="logo-container">
          <img src={logo} className="logo" alt="Hexagon logo"/>
        </div>
      </Link>
    </div>
  </div>
}